export default {
  qrCode: state => state.qrCode,
}



// WEBPACK FOOTER //
// ./src/store/modules/mfa/mfa.getters.js